module.exports = __webpack_public_path__ + "img/carparking2.5f25fbe7.webp";